import React, { Fragment, PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";

import { selectCopy } from "../../../state/reducers/locale/copySelector.js";

class WizardDetailsPanelSummary extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    formikProps: PropTypes.object.isRequired, // required for ResourceBlock selectors to function
    copyKey: PropTypes.string.isRequired,

    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "project_wizard.details_panel"
  };

  // -- RENDER -- //

  renderActive() {
    const {
      formikProps: { values },
      copyKey,
      copy
    } = this.props;

    return (
      <Fragment>
        <p>
          <strong>{copy(`${copyKey}.name_input_label`)}: </strong>
          {values.name}
          <br />
          {values.description && (
            <Fragment>
              <strong>{copy(`${copyKey}.description_input_label`)}: </strong>
              <br />
              {values.description}
            </Fragment>
          )}
        </p>
      </Fragment>
    );
  }

  renderInactive() {
    return null;
  }

  render() {
    const {
      formikProps: { values }
    } = this.props;

    const name = values.name;

    if (name && name !== "") {
      return this.renderActive();
    }

    return this.renderInactive();
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(WizardDetailsPanelSummary);
